export default {
  todayAppointment: 'นัดวันนี้',
  person: 'คน',
  receptionDesk: 'โต๊ะต้อนรับ',
  queue: 'คิว',
  selectRoom: 'เลือกการแสดงห้อง'
}
